<div [editableInStoryblok]="_editable">
	<h2 [ngClass]="headingSize()">{{ title }}</h2>
</div>
